import { formatPhoneInput } from "../domain/phone";

type PhoneInputProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  invalid?: boolean;
};

export function PhoneInput({ id, value, onChange, required, invalid }: PhoneInputProps) {
  return (
    <input
      id={id}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder="(231) 555-0100"
      value={value}
      required={required}
      aria-invalid={invalid ? true : undefined}
      aria-describedby={invalid ? `${id}-error` : undefined}
      onChange={(event) => onChange(formatPhoneInput(event.target.value))}
    />
  );
}
